/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_ConfirmInputs */

const en_booking_confirm = /** @type {(inputs: Booking_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm booking`)
};

const es_booking_confirm = /** @type {(inputs: Booking_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar reserva`)
};

const de_booking_confirm = /** @type {(inputs: Booking_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchung bestätigen`)
};

const zh_booking_confirm = /** @type {(inputs: Booking_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确认预订`)
};

const ar_booking_confirm = /** @type {(inputs: Booking_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تأكيد الحجز`)
};

const fr_booking_confirm = /** @type {(inputs: Booking_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmer la réservation`)
};

const vi_booking_confirm = /** @type {(inputs: Booking_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xác nhận đặt chỗ`)
};

const sw_booking_confirm = /** @type {(inputs: Booking_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thibitisha kuweka nafasi`)
};

const th_booking_confirm = /** @type {(inputs: Booking_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยืนยันการจอง`)
};

const bs_booking_confirm = /** @type {(inputs: Booking_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potvrdi rezervaciju`)
};

const ja_booking_confirm = /** @type {(inputs: Booking_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`予約を確定する`)
};

const ko_booking_confirm = /** @type {(inputs: Booking_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`예약 확정`)
};

const pt_booking_confirm = /** @type {(inputs: Booking_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar reserva`)
};

const it_booking_confirm = /** @type {(inputs: Booking_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conferma prenotazione`)
};

const sv_booking_confirm = /** @type {(inputs: Booking_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekräfta bokning`)
};

const nl_booking_confirm = /** @type {(inputs: Booking_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bevestig boeking`)
};

const da_booking_confirm = /** @type {(inputs: Booking_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekræft booking`)
};

const nb_booking_confirm = /** @type {(inputs: Booking_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekreft bestilling`)
};

const fi_booking_confirm = /** @type {(inputs: Booking_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vahvista varaus`)
};

const pl_booking_confirm = /** @type {(inputs: Booking_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potwierdź rezerwację`)
};

const ru_booking_confirm = /** @type {(inputs: Booking_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подтвердить бронирование`)
};

const tr_booking_confirm = /** @type {(inputs: Booking_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervasyonu onayla`)
};

const hi_booking_confirm = /** @type {(inputs: Booking_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बुकिंग की पुष्टि करें`)
};

const id_booking_confirm = /** @type {(inputs: Booking_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfirmasi pemesanan`)
};

const ms_booking_confirm = /** @type {(inputs: Booking_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sahkan tempahan`)
};

const cs_booking_confirm = /** @type {(inputs: Booking_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potvrdit rezervaci`)
};

const el_booking_confirm = /** @type {(inputs: Booking_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επιβεβαίωση κράτησης`)
};

const he_booking_confirm = /** @type {(inputs: Booking_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אישור הזמנה`)
};

const af_booking_confirm = /** @type {(inputs: Booking_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bevestig bespreking`)
};

const hu_booking_confirm = /** @type {(inputs: Booking_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foglalás megerősítése`)
};

/**
* | output |
* | --- |
* | "Confirm booking" |
*
* @param {Booking_ConfirmInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_confirm = /** @type {((inputs?: Booking_ConfirmInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_ConfirmInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_confirm(inputs)
	if (locale === "de") return de_booking_confirm(inputs)
	if (locale === "zh") return zh_booking_confirm(inputs)
	if (locale === "ar") return ar_booking_confirm(inputs)
	if (locale === "fr") return fr_booking_confirm(inputs)
	if (locale === "vi") return vi_booking_confirm(inputs)
	if (locale === "sw") return sw_booking_confirm(inputs)
	if (locale === "th") return th_booking_confirm(inputs)
	if (locale === "bs") return bs_booking_confirm(inputs)
	if (locale === "ja") return ja_booking_confirm(inputs)
	if (locale === "ko") return ko_booking_confirm(inputs)
	if (locale === "pt") return pt_booking_confirm(inputs)
	if (locale === "it") return it_booking_confirm(inputs)
	if (locale === "sv") return sv_booking_confirm(inputs)
	if (locale === "nl") return nl_booking_confirm(inputs)
	if (locale === "da") return da_booking_confirm(inputs)
	if (locale === "nb") return nb_booking_confirm(inputs)
	if (locale === "fi") return fi_booking_confirm(inputs)
	if (locale === "pl") return pl_booking_confirm(inputs)
	if (locale === "ru") return ru_booking_confirm(inputs)
	if (locale === "tr") return tr_booking_confirm(inputs)
	if (locale === "hi") return hi_booking_confirm(inputs)
	if (locale === "id") return id_booking_confirm(inputs)
	if (locale === "ms") return ms_booking_confirm(inputs)
	if (locale === "cs") return cs_booking_confirm(inputs)
	if (locale === "el") return el_booking_confirm(inputs)
	if (locale === "he") return he_booking_confirm(inputs)
	if (locale === "af") return af_booking_confirm(inputs)
	if (locale === "hu") return hu_booking_confirm(inputs)
	return en_booking_confirm(inputs)
});